import { render, staticRenderFns } from "./LoginTexts.vue?vue&type=template&id=72a32242&scoped=true&"
import script from "./LoginTexts.vue?vue&type=script&lang=js&"
export * from "./LoginTexts.vue?vue&type=script&lang=js&"
import style0 from "./LoginTexts.vue?vue&type=style&index=0&id=72a32242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a32242",
  null
  
)

export default component.exports